import Http from "../../http/client";

export default async () => {
  const response = await Http.get('admin/vehicle/manufacturers');
  return response.data;
}
